import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppDispatch, RootState } from "../../apis/store";
import { setDonationAmount } from "../../apis/slices/globalSlice";
import EhsanLogo from "../../assets/ehsan_logo.svg";

const PRESET_AMOUNTS = [10, 20, 50, 100] as const;

type Props = {
  className?: string;
};

const DonationSection = ({ className }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const donationAmount = useSelector(
    (state: RootState) => state.global.donationAmount
  );
  const isRtl = i18n.language === "ar";
  const numericDonation = Number(donationAmount);

  const sectionClass = ["ac-donation-section", className]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className={sectionClass}
      aria-label={t("profile.order.cart.donation")}
    >
      <header className="ac-donation-section__header">
        <div className="ac-donation-section__logo-wrap">
          <img
            className="ac-donation-section__logo"
            src={EhsanLogo}
            alt={t("profile.order.cart.donationEhsanAlt")}
            width={77}
            height={90}
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="ac-donation-section__intro">
          <h3 className="ac-donation-section__title ac--font-expo">
            {t("profile.order.cart.donation")}
          </h3>
          <p className="ac-donation-section__lead ac--font-expo">
            {t("profile.order.cart.donationViaEhsan")}
          </p>
        </div>
      </header>

      <div className="ac-donation-section__amounts" role="group">
        {PRESET_AMOUNTS.map((amount) => {
          const isActive =
            Number.isFinite(numericDonation) && numericDonation === amount;
          return (
            <button
              key={amount}
              type="button"
              className={`ac-donation-section__amount-btn icon-saudi_riyal${
                isActive ? " ac-donation-section__amount-btn--active" : ""
              }`}
              aria-pressed={isActive}
              onClick={() => dispatch(setDonationAmount(amount))}
            >
              {amount}
            </button>
          );
        })}
      </div>

      <div className="ac-donation-section__custom">
        {!isRtl ? (
          <span
            className="ac-donation-section__currency icon-saudi_riyal"
            aria-hidden
          />
        ) : null}
        <input
          className="ac-donation-section__input ac--coupon-input"
          placeholder={t("profile.order.cart.otherAmount")}
          type="number"
          min="0"
          inputMode="decimal"
          value={donationAmount > 0 ? donationAmount : ""}
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;
            if (value !== "" && Number(value) < 0) {
              dispatch(setDonationAmount(0));
              return;
            }
            dispatch(setDonationAmount(value === "" ? 0 : value));
          }}
        />
        {isRtl ? (
          <span
            className="ac-donation-section__currency icon-saudi_riyal"
            aria-hidden
          />
        ) : null}
      </div>
    </section>
  );
};

export default DonationSection;
